<div class="bredcrumbWrp">
  <ul>
    <li>
      <a routerLink="/rfq"> RFQ </a>
    </li>
    <li *ngIf="update_rfqId != 'add'">Update RFQ</li>
    <li *ngIf="update_rfqId == 'add'">Create RFQ</li>
  </ul>
</div>
<div class="pageWrapper pt-0">
  <h2 *ngIf="update_rfqId != 'add'" class="pageTitle">
    Update {{ rfqTemplateType }} RFQ
  </h2>
  <h2 *ngIf="update_rfqId == 'add'" class="pageTitle">
    Create {{ rfqTemplateType }} RFQ
  </h2>
  <div class="stepperRfq">
    <form [formGroup]="createRfq" class="wrappInside">
      <mat-stepper #stepper [linear]="true" *ngIf="!isHide">
        <mat-step
          label="Project Information"
          [stepControl]="
            createRfq.get('projectName')! && createRfq.get('rfqTemplate')!
          "
          [completed]="createRfq.valid"
          [editable]="true"
        >
          <div class="stepperWrapp">
            <div class="stepperCenter">
              <div class="row">
                <div class="col-sm-12">
                  <div class="formGroup">
                    <label>Project Name<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input
                        id="modules_rfq_createrfq_1"
                        maxlength="200"
                        matInput
                        formControlName="projectName"
                        placeholder="Your Project Name"
                      />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div
                        *ngIf="
                          createRfq?.get('projectName')?.touched ||
                          createRfq?.get('projectName')?.dirty
                        "
                      >
                        <div
                          *ngIf="
                            createRfq?.get('projectName')?.hasError('required')
                          "
                        >
                          Project name is required
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6 rfq_select">
                  <!-- <div class="formGroup">
                                        <label class="flex">Select RFQ Template<sup>*</sup></label>
                                            <mat-radio-group formControlName="rfqTemplate" (change)="onRadioChange($event)">
                                                <mat-radio-button value="Tooling">Tooling</mat-radio-button>
                                                <mat-radio-button value="Component">Component</mat-radio-button>
                                                <mat-radio-button value="CapEx">CapEx</mat-radio-button>
                                            </mat-radio-group>
                                    </div> -->

                  <div class="formGroup">
                    <label class="flex">Select RFQ Template<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <mat-select
                        id="modules_rfq_createrfq_2"
                        formControlName="rfqTemplate"
                        placeholder="RFQ Template"
                        (selectionChange)="onFileSelected()"
                      >
                        <mat-option
                          *ngFor="let option of templateTypeDropdownOptions"
                          [value]="option.label"
                        >
                          {{ option.value }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                      <!-- <div
                                                *ngIf="createRfq?.get('rfqTemplate')?.touched || createRfq?.get('rfqTemplate')?.dirty">
                                                <div *ngIf="createRfq?.get('rfqTemplate')?.hasError('required')">
                                                    RFQ Template is required
                                                </div>
                                            </div> -->
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="isOther || isRefrigeration">
                  <div class="formGroup">
                    <label *ngIf="!isRefrigeration">RFQ Type<sup>*</sup></label>
                    <label *ngIf="isRefrigeration">RFQ Description</label>

                    <mat-form-field appearance="outline">
                      <input
                        id="modules_rfq_createrfq_otherfiles"
                        matInput
                        formControlName="otherRFQType"
                        placeholder="RFQ Type Name"
                        *ngIf="!isRefrigeration"
                      />

                      <textarea
                        id="modules_rfq_createrfq_otherfiles"
                        matInput
                        formControlName="otherRFQType"
                        placeholder="RFQ Description"
                        *ngIf="isRefrigeration"
                      ></textarea>
                    </mat-form-field>
                    <div class="errorTxt">
                      <div
                        *ngIf="
                          createRfq?.get('otherRFQType')?.touched ||
                          createRfq?.get('otherRFQType')?.dirty
                        "
                      >
                        <div
                          *ngIf="
                            createRfq?.get('otherRFQType')?.hasError('required')
                          "
                        >
                          RFQ Type is required
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-sm-6"
                  *ngIf="isOther || isRemainingOther || isRefrigeration"
                >
                  <div class="formGroup">
                    <label>Template Type</label>
                    <mat-radio-group
                      aria-label="Select an option"
                      formControlName="otherTemplateType"
                    >
                      <mat-radio-button value="custom"
                        >Custom Template</mat-radio-button
                      >
                      <mat-radio-button value="standard"
                        >Unibuild's Standard Template</mat-radio-button
                      >
                    </mat-radio-group>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="formGroup">
                    <div
                      class="popupDropdown downloadFile"
                      *ngIf="selectedOption"
                    >
                      <div class="flex alignCenter">
                        <span
                          class="iconCenter"
                          (click)="downloadFile(selectedOption)"
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_8832_38514"
                              style="mask-type: alpha"
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="24"
                              height="24"
                            >
                              <rect
                                width="24"
                                height="24"
                                fill="#D9D9D9"
                              ></rect>
                            </mask>
                            <g mask="url(#mask0_8832_38514)">
                              <path
                                d="M12 15.7884L7.7308 11.5192L8.78462 10.4347L11.25 12.9V4.5H12.7499V12.9L15.2153 10.4347L16.2692 11.5192L12 15.7884ZM6.3077 19.5C5.80257 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6922V14.9807H5.99997V17.6922C5.99997 17.7692 6.03202 17.8397 6.09612 17.9038C6.16024 17.9679 6.23077 18 6.3077 18H17.6922C17.7692 18 17.8397 17.9679 17.9038 17.9038C17.9679 17.8397 18 17.7692 18 17.6922V14.9807H19.5V17.6922C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6922 19.5H6.3077Z"
                                fill="#DA2128"
                              ></path>
                            </g>
                          </svg>
                        </span>
                      </div>
                      <div class="flex alignCenter">
                        <span class="chip-item">
                          Download Sample {{ selectedOption }}.xlsx
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6" *ngIf="!isRefrigeration">
                  <div class="formGroup">
                    <label>Category<sup>*</sup></label>
                    <div class="popupDropdown">
                      <div class="flex alignCenter" *ngIf="!categoryData">
                        <span class="iconCenter" (click)="showCategory()">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24"
                            viewBox="0 -960 960 960"
                            width="24"
                            class="badge-notfication"
                          >
                            <path
                              _ngcontent-ng-c846756250=""
                              d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                            ></path>
                          </svg>
                        </span>
                        <span class="placeholderText">Select Category</span>
                      </div>
                      <div class="flex alignCenter chipWrapper">
                        <ng-container
                          *ngFor="
                            let category of selectedCategories;
                            let i = index
                          "
                        >
                          <span class="chip-item">
                            <ng-container *ngIf="i < 3">
                              <mat-chip *ngIf="category.name?.length > 0">
                                {{ category.name }}
                                <mat-icon (click)="removeCategory(category.id)"
                                  >close</mat-icon
                                >
                              </mat-chip>
                            </ng-container>
                            <!-- Display "+X" for chips exceeding the first two -->
                            <ng-container
                              *ngIf="i >= 3  && i === selectedCategories.length - 1">
                              <span class="count"
                              matTooltipPosition="right"
                              matTooltip="{{getHiddenCategoryNames(selectedCategories)}}">
                                +{{ selectedCategories.length - 3 }}
                              </span>
                            </ng-container>
                          </span>
                        </ng-container>
                        <span
                          class="iconCenter materialEdit"
                          (click)="showCategory()"
                          *ngIf="categoryData"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24"
                            viewBox="0 -960 960 960"
                            width="24"
                            class="badge-notfication"
                          >
                            <path
                              _ngcontent-ng-c846756250=""
                              d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                            ></path>
                          </svg>
                        </span>
                      </div>
                    </div>
                    <div class="drpdownShow" *ngIf="popupShow">
                      <app-popup-dropdown
                        (categoryParent)="receiveCategoryChild($event)"
                        [categoriesData]="categoriesData"
                        [alreadySelectedCategories]="alreadySelectedCategories"
                        [alreadySelectedSubCategories]="
                          alreadySelectedSubCategories
                          "
                        (backButton)="hidePopup()"
                        (updateOtherSubCatValue)="handleOthersInputData($event)"
                        [otherSubCategoryValue]="othersInputData.category"
                      ></app-popup-dropdown>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="!isRemainingOther">
                  <div class="formGroup">
                    <label
                      >Material
                      <sup
                        *ngIf="
                          !isOther && !isRemainingOther && !isRefrigeration
                        "
                        >*</sup
                      ></label
                    >
                    <div class="popupDropdown">
                      <div class="flex alignCenter">
                        <span class="iconCenter" (click)="showMaterial()">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24"
                            viewBox="0 -960 960 960"
                            width="24"
                            class="badge-notfication"
                          >
                            <path
                              _ngcontent-ng-c846756250=""
                              d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                            ></path>
                          </svg>
                        </span>
                        <span class="placeholderText">Select Material</span>
                      </div>
                      <div class="flex alignCenter chipWrapper">
                        <ng-container
                          *ngFor="
                            let material of selectedMaterials;
                            let i = index
                          "
                        >
                          <span class="chip-item">
                            <ng-container *ngIf="i < 3">
                              <mat-chip *ngIf="material.name?.length > 0">
                                {{ material.name }}
                                <mat-icon (click)="removeMaterial(material.id)"
                                  >close</mat-icon
                                >
                              </mat-chip>
                            </ng-container>
                            <!-- Display "+X" for materials exceeding the first two -->
                            <ng-container
                              *ngIf="
                                i >= 3 && i === selectedMaterials.length - 1
                              "
                            >
                              <span class="count"
                              matTooltipPosition="right"
                              matTooltip="{{getHiddenCategoryNames(selectedMaterials)}}">
                                +{{ selectedMaterials.length - 3 }}
                              </span>
                            </ng-container>
                          </span>
                        </ng-container>
                      </div>
                    </div>
                    <!-- <p>Data Received in parent: {{ materialData  | json }}</p> -->
                    <div class="drpdownShow" *ngIf="materialPopupShow">
                      <app-material-dropdown
                        (materialParent)="receiveMaterialChild($event)"
                        (backMaterial)="hideMaterial()"
                        (onInputOtherMaterial) = handleOthersInputData($event)
                        [otherMaterialValue]="this.othersInputData.material"
                        [alreadyMaterials]="alreadyMaterials"
                        [materialData]="materialData"
                      ></app-material-dropdown>
                    </div>
                  </div>
                </div>
                <div class="col-md-6" *ngIf="!isRefrigeration">
                  <div class="formGroup">
                    <label>Secondary Process (if any)</label>
                    <mat-form-field appearance="outline">
                      <mat-select
                        id="modules_rfq_createrfq_3"
                        formControlName="secondaryProcesses"
                        placeholder="Select Items"
                        multiple
                      >
                        <mat-optgroup
                          *ngFor="let secondary of secondaryProcessData"
                          [label]="secondary.secondaryProcessName"
                        >
                          <mat-option
                            *ngFor="let item of secondary.subSecondaryProcess"
                            [value]="item.subSecondaryProcessId"
                          >
                            {{ item.subSecondaryProcessName }}
                          </mat-option>
                        </mat-optgroup>
                      </mat-select>
                      <!-- <button mat-button (click)="selectAll()">Select All</button>
                                            <button mat-button (click)="deselectAll()">Deselect All</button> -->
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6" *ngIf="!isRefrigeration">
                  <div class="formGroup">
                    <label>Type of Development<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <mat-select
                        id="modules_rfq_createrfq_4"
                        placeholder="Select project"
                        formControlName="existingProject"
                      >
                        <mat-option value="false"
                          >New product development</mat-option
                        >
                        <mat-option value="true"
                          >Existing product manufacturing</mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                      <div
                        *ngIf="
                          createRfq?.get('existingProject')?.touched ||
                          createRfq?.get('existingProject')?.dirty
                        "
                      >
                        <div
                          *ngIf="
                            createRfq
                              ?.get('existingProject ')
                              ?.hasError('required')
                          "
                        >
                          Type of development is required
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ....... -->

                <div class="col-md-6">
                  <div class="formGroup">
                    <label
                      >Incoterms<sup>*</sup
                      ><lucide-icon
                        name="info"
                        [size]="14"
                        matTooltipPosition="right"
                        matTooltip="Select the Incoterm that defines your shipping and delivery responsibilities for this order during checkout"
                      ></lucide-icon
                    ></label>
                    <mat-form-field appearance="outline">
                      <mat-select
                        id="modules_rfq_createrfq_4"
                        placeholder="Select project"
                        formControlName="incoTerm"
                      >
                        <mat-option
                          value="{{ item.name }}"
                          *ngFor="let item of incotermLists"
                          >{{ item.name }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="formGroup">
                    <label
                      >Payment Terms<sup>*</sup
                      ><lucide-icon
                        name="info"
                        [size]="14"
                        matTooltip="Choose the payment term that outlines your payment schedule and conditions for this order during checkout"
                        matTooltipPosition="right"
                      ></lucide-icon
                    ></label>
                    <mat-form-field appearance="outline">
                      <mat-select
                        id="modules_rfq_createrfq_4"
                        placeholder="Select project"
                        formControlName="paymentTerm"
                        (selectionChange)="paymentTermChanged($event)"
                      >
                        <mat-option
                          value="{{ item.name }}"
                          *ngFor="let item of paymentTermData"
                          >{{ item.name }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6" *ngIf="isPaymentRemarksVisible">
                  <div class="formGroup">
                    <label>Payment Terms Remarks <sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input
                        id="modules_rfqmodule_splitrfq_splitrfqquote_401_paymentRemarks"
                        matInput
                        formControlName="paymentTermRemarks"
                        placeholder="Payment Terms Remarks"
                      />
                    </mat-form-field>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="formGroup">
                    <label>Delivery Date<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input
                        matInput
                        placeholder="Delivery Date"
                        [matDatepicker]="picker"
                        formControlName="deliveryDate"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="picker"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="formGroup">
                    <label>Quantity<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input
                        id="modules_rfqmodule_splitrfq_splitrfqquote_401"
                        matInput
                        formControlName="minimumOrderQuantity"
                        type="number"
                        placeholder="Quantity"
                        maxlength="10"
                        min="0"
                      />
                    </mat-form-field>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="formGroup">
                    <label>Delivery Address<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input
                        id="modules_rfqmodule_splitrfq_splitrfqquote_401"
                        matInput
                        formControlName="address"
                        placeholder="Delivery Address"
                      />
                    </mat-form-field>
                  </div>
                </div>

                <!-- ......... -->

                <div class="saveButton">
                  <button
                    id="modules_rfq_createrfq_5"
                    mat-button
                    color="primary"
                    type="button"
                    class="btnCustom btn-primary"
                    (click)="sendRfq()"
                    [ngClass]="{ disable: isFirstStepValid() }"
                    matStepperNext
                  >
                    Save & Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </mat-step>
        <mat-step
          label="Upload Specification"
          [completed]="
            (createRfq.valid && !disableSaveAndContinue()) ||
            (createRfq.valid && selectedOption == 'CommercialRefrigeration')
          "
        >
          <div class="stepperWrapp">
            <div class="stepperCenter">
              <span class="back-step-button" (click)="backStep(stepper)">
                <lucide-icon name="ArrowLeft" class="back-icon"></lucide-icon>
                Back
              </span>
              <div
                class="uploadSpecification upload"
                appDnd
                #fileDropRef
                id="fileDropRef"
                (fileDropped)="onFileDroppedRfq($event)"
              >
                <h3>Upload {{ selectedOption }} RFQ</h3>
                <p class="font-12">
                  To receive a quote, kindly upload the RFQ template with the
                  filled details.
                </p>
                <p class="mb-4 font-12">Drag & Drop or upload .xls, .xlsx</p>
                <input
                  id="modules_rfq_createrfq_6"
                  type="file"
                  #fileSelector
                  accept=".xlsx, .xls"
                  (change)="fileBrowseHandlerSingle($event)"
                  style="display: none"
                />
                <button
                  id="modules_rfq_createrfq_7"
                  class="btnCustom btn-rfq"
                  (click)="chooseFileSingle()"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="16"
                    viewBox="0 0 14 16"
                    fill="none"
                  >
                    <path
                      d="M2.43921 8.39014H3.5119L4.07348 9.55352L4.61583 8.39014H5.67676L4.69669 10.2217L5.7707 12.172H4.67456L4.05405 10.9568L3.42965 12.172H2.34131L3.42965 10.201L2.43921 8.39014Z"
                      fill="#DA2128"
                    />
                    <path
                      d="M6.08398 8.39014H7.05877V11.239H8.57769V12.1721H6.08398V8.39014Z"
                      fill="#DA2128"
                    />
                    <path
                      d="M8.85303 10.9209L9.78098 10.8509C9.80093 11.032 9.84149 11.1699 9.90299 11.2648C10.0029 11.4184 10.1456 11.495 10.3311 11.495C10.4695 11.495 10.5761 11.4559 10.6512 11.3776C10.7261 11.2992 10.7635 11.2085 10.7635 11.1054C10.7635 11.0073 10.728 10.9195 10.657 10.8421C10.5859 10.7646 10.4199 10.6916 10.1592 10.6228C9.73216 10.5075 9.42775 10.3544 9.24582 10.1631C9.06237 9.97203 8.97061 9.72846 8.97061 9.43225C8.97061 9.23777 9.01758 9.05392 9.11152 8.88091C9.20533 8.7079 9.34663 8.57175 9.5351 8.47272C9.72364 8.37376 9.98206 8.32422 10.3103 8.32422C10.7132 8.32422 11.0203 8.41419 11.2318 8.59414C11.4432 8.77422 11.569 9.0604 11.6092 9.45299L10.6892 9.51753C10.6649 9.34743 10.6135 9.2237 10.5356 9.14634C10.4576 9.06905 10.3498 9.03034 10.2124 9.03034C10.0993 9.03034 10.0141 9.05921 9.95683 9.11688C9.89962 9.17455 9.87088 9.2447 9.87088 9.32728C9.87088 9.38753 9.89453 9.44163 9.9419 9.48985C9.98774 9.53979 10.0967 9.58623 10.2686 9.62917C10.6941 9.73936 10.9992 9.85074 11.1832 9.96351C11.3673 10.0761 11.5013 10.216 11.5851 10.3829C11.669 10.5498 11.7109 10.7365 11.7109 10.943C11.7109 11.1857 11.6548 11.4094 11.5433 11.614C11.4316 11.8188 11.2753 11.974 11.0748 12.0799C10.8742 12.1857 10.6215 12.2386 10.3164 12.2386C9.78058 12.2386 9.40945 12.1146 9.20321 11.8666C8.99704 11.6182 8.88031 11.3031 8.85303 10.9209Z"
                      fill="#DA2128"
                    />
                    <path
                      d="M12.7634 4.10287L9.39944 0.831104C8.92024 0.365049 8.02129 0 7.35276 0H1.86282C1.04321 0 0.376465 0.666747 0.376465 1.48636V14.5136C0.376465 15.3332 1.04321 16 1.86282 16H12.1374C12.9569 16 13.6237 15.3332 13.6237 14.5136V6.13984C13.6237 5.45566 13.2539 4.57996 12.7634 4.10287ZM12.0724 4.81322C12.1915 4.92902 12.3059 5.10237 12.4003 5.29447H8.67919C8.40596 5.29447 8.18373 5.07224 8.18373 4.79902V1.20553C8.39209 1.30066 8.58221 1.41864 8.70852 1.54152L12.0724 4.81322ZM12.1374 15.0091H1.86282C1.5896 15.0091 1.36737 14.7869 1.36737 14.5136V1.48636C1.36737 1.21313 1.5896 0.990904 1.86282 0.990904H7.19283V4.79902C7.19283 5.61863 7.85964 6.28537 8.67919 6.28537H12.6329V14.5136C12.6328 14.7869 12.4106 15.0091 12.1374 15.0091Z"
                      fill="#DA2128"
                    />
                  </svg>
                  Upload RFQ
                </button>
              </div>

              <div class="error_message" *ngIf="errorMessage && !SingleFile">
                <div class="error_box">
                  <div class="heading flex">
                    <span class="icon"
                      ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12 7L12 13"
                          stroke="#6D1014"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12 17.01L12.01 16.9989"
                          stroke="#6D1014"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                          stroke="#6D1014"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <h3>{{ errorMessage }}</h3>
                  </div>
                  <p *ngIf="invalidFile">
                    {{ errorText }}
                  </p>
                </div>
              </div>

              <div *ngIf="SingleFile" class="files-list">
                <div class="single-file flex justify-content-between">
                  <div class="flex file">
                    <div class="rfq-item rfq-icon">
                      <lucide-icon name="FileText" class="icon"></lucide-icon>
                      <h4>
                        {{ getFileName(SingleFile.name) }}.<span class="name">{{
                          getFileExt(SingleFile.name)
                        }}</span>
                      </h4>
                    </div>
                    <div class="info">
                      <h4 class="name">{{ formatBytes(SingleFile.size) }}</h4>
                    </div>
                  </div>

                  <span class="rfqItem rfqDownloadIco" (click)="deleteRfq()">
                    <lucide-icon name="Trash" class="icon"></lucide-icon>
                  </span>
                </div>
              </div>

              <div class="downloadComponent">
                <span (click)="downloadFile(selectedOption)"
                  >Download {{ selectedOption }}
                  <!-- {{ isOther ? "(" + (createRfq!.get("otherRFQType")!.value ?? "") + ")" : "" }} -->
                  RFQ Template</span
                >
              </div>
              <div class="saveButton">
                <button
                  id="modules_rfq_createrfq_8"
                  mat-button
                  color="primary"
                  [disabled]="disableSaveAndContinue()"
                  type="button"
                  class="btnCustom btn-primary"
                  matStepperNext
                  (click)="updateRFQFile()"
                >
                  Save & Continue
                </button>
                <button
                  *ngIf="selectedOption == 'CommercialRefrigeration'"
                  id="modules_rfq_createrfq_8skip"
                  mat-button
                  color="primary"
                  type="button"
                  class="btnCustomSkip btn-primary"
                  matStepperNext
                >
                  Skip
                </button>
              </div>
            </div>
          </div>
        </mat-step>

        <mat-step label="Upload Drawing">
          <div class="stepperWrapp">
            <!-- upload 2D Model  -->
            <div class="stepperCenter">
              <span class="back-step-button" (click)="backStep(stepper)">
                <lucide-icon name="ArrowLeft" class="back-icon"></lucide-icon>
                Back
              </span>
              <mat-accordion>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <h3 *ngIf="is2DMandatory">
                        Upload 2D Model for {{ temp }} (Mandatory)
                      </h3>
                      <h3 *ngIf="!is2DMandatory">
                        Upload 2D Model for {{ temp }} (Optional)
                      </h3>
                    </mat-panel-title>
                    <mat-panel-description> </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div
                    class="uploadSpecification"
                    appDnd
                    #fileDrop2D
                    id="fileDrop2D"
                    (fileDropped)="on2DFileDropped($event)"
                  >
                    <input
                      type="file"
                      #fileSelector2DMultiple
                      multiple
                      (change)="file2DHandler($event)"
                      style="display: none"
                      accept=".jpeg, .jpg, .png, .pdf, .doc, .docx, .zip, .dwg, .dxf, .dgn, .stl , .iges, .JPEG, .JPG, .PNG, .PDF, .DOC, .DOCX, .ZIP, .DWG, .DXF, .DGN, .STL, .IGES"
                    />
                    <h3>Upload</h3>
                    <p class="medium font-12">(Max. file size: 100 MB)</p>
                    <span class="dwn_icon">
                      <svg
                        width="53"
                        height="53"
                        viewBox="0 0 53 53"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.61001 20.5043H5.51001V20.6043V47.3957V47.4957H5.61001H32.39H32.49V47.3957V20.6043V20.5043H32.39H5.61001ZM10.0001 42.9213V43.0213H10.1001H28.6046V44.4256H8.59006V24.4653H10.0001V42.9213ZM4.1 48.9V19.1H33.9V48.9H4.1Z"
                          fill="#999999"
                          stroke="white"
                          stroke-width="0.2"
                        />
                        <path
                          d="M4.35355 0.646446C4.15829 0.451183 3.84171 0.451183 3.64645 0.646446L0.464466 3.82843C0.269204 4.02369 0.269204 4.34027 0.464466 4.53553C0.659728 4.7308 0.976311 4.7308 1.17157 4.53553L4 1.70711L6.82843 4.53553C7.02369 4.7308 7.34027 4.7308 7.53553 4.53553C7.7308 4.34027 7.7308 4.02369 7.53553 3.82843L4.35355 0.646446ZM4.5 49L4.5 1H3.5L3.5 49H4.5Z"
                          fill="#999999"
                        />
                        <path
                          d="M4 48.5H3.5V49.5H4V48.5ZM52.3536 49.3536C52.5488 49.1583 52.5488 48.8417 52.3536 48.6464L49.1716 45.4645C48.9763 45.2692 48.6597 45.2692 48.4645 45.4645C48.2692 45.6597 48.2692 45.9763 48.4645 46.1716L51.2929 49L48.4645 51.8284C48.2692 52.0237 48.2692 52.3403 48.4645 52.5355C48.6597 52.7308 48.9763 52.7308 49.1716 52.5355L52.3536 49.3536ZM4 49.5H52V48.5H4V49.5Z"
                          fill="#999999"
                        />
                      </svg>
                    </span>
                    <p class="mb-4 font-12">Drag & Drop or</p>
                    <button
                      id="modules_rfq_createrfq_9"
                      class="btnCustom btn-rfq"
                      (click)="choose2DFiles()"
                    >
                      Choose File
                    </button>
                    <p class="mb-0 mt-5 medium font-10">
                      JPEG | JPG | PNG | PDF | DOC | DOCX | ZIP | DWG | DXF |
                      DGN | STL |IGES
                    </p>
                  </div>
                  <div class="rfqListing">
                    <!-- <h3 class="font-12 medium">RFQ</h3> -->
                    <div
                      class="single-file flex justify-content-between"
                      *ngFor="let file of Multiple2DFile; let i = index"
                    >
                      <div class="flex file">
                        <div class="rfqItem rfqTitle medium rfq-item rfq-icon">
                          <lucide-icon
                            name="FileText"
                            class="icon"
                          ></lucide-icon>
                          <h4
                            matTooltip="{{ getFileName(file?.name) }}"
                            class="name"
                          >
                            {{ getFileName(file?.name) }}.
                            <span class="name">{{
                              getFileExt(file?.name)
                            }}</span>
                          </h4>
                        </div>
                        <div class="info">
                          <h4 class="name">{{ formatBytes(file?.size) }}</h4>
                        </div>
                      </div>

                      <span
                        class="rfqItem rfqDownloadIco"
                        (click)="delete2DFile(i)"
                      >
                        <lucide-icon name="Trash" class="icon"></lucide-icon>
                      </span>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
            <!-- uplado video files -->
            <div class="stepperCenter" *ngIf="isVideoSelection">
              <mat-accordion>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <h3>Upload Videos for {{ temp }} (Optional)</h3>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div
                    class="uploadSpecification"
                    appDnd
                    #fileDropVideo
                    id="fileDropVideo"
                    (fileDropped)="onVideoDropped($event)"
                  >
                    <input
                      id="videoUploader"
                      type="file"
                      #fileSelectorVideo
                      multiple
                      (change)="videoFileHandler($event)"
                      style="display: none"
                      accept=".mp4, .avi, .mov"
                    />
                    <h3>Upload Videos for {{ temp }}</h3>
                    <p class="medium font-12">(Max. file size: 500 MB)</p>
                    <span class="dwn_icon">
                      <svg
                        width="53"
                        height="53"
                        viewBox="0 0 53 53"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.61001 20.5043H5.51001V20.6043V47.3957V47.4957H5.61001H32.39H32.49V47.3957V20.6043V20.5043H32.39H5.61001ZM10.0001 42.9213V43.0213H10.1001H28.6046V44.4256H8.59006V24.4653H10.0001V42.9213ZM4.1 48.9V19.1H33.9V48.9H4.1Z"
                          fill="#999999"
                          stroke="white"
                          stroke-width="0.2"
                        />
                        <path
                          d="M4.35355 0.646446C4.15829 0.451183 3.84171 0.451183 3.64645 0.646446L0.464466 3.82843C0.269204 4.02369 0.269204 4.34027 0.464466 4.53553C0.659728 4.7308 0.976311 4.7308 1.17157 4.53553L4 1.70711L6.82843 4.53553C7.02369 4.7308 7.34027 4.7308 7.53553 4.53553C7.7308 4.34027 7.7308 4.02369 7.53553 3.82843L4.35355 0.646446ZM4.5 49L4.5 1H3.5L3.5 49H4.5Z"
                          fill="#999999"
                        />
                        <path
                          d="M4 48.5H3.5V49.5H4V48.5ZM52.3536 49.3536C52.5488 49.1583 52.5488 48.8417 52.3536 48.6464L49.1716 45.4645C48.9763 45.2692 48.6597 45.2692 48.4645 45.4645C48.2692 45.6597 48.2692 45.9763 48.4645 46.1716L51.2929 49L48.4645 51.8284C48.2692 52.0237 48.2692 52.3403 48.4645 52.5355C48.6597 52.7308 48.9763 52.7308 49.1716 52.5355L52.3536 49.3536ZM4 49.5H52V48.5H4V49.5Z"
                          fill="#999999"
                        />
                      </svg>
                    </span>
                    <p class="mb-4 font-12">Drag &amp; Drop or</p>
                    <button
                      id="modules_rfq_createrfq_11"
                      class="btnCustom btn-rfq"
                      (click)="chooseVideoFile()"
                    >
                      Choose Video File
                    </button>
                    <p class="mb-0 mt-5 medium font-10">MP4 | AVI | MOV</p>
                  </div>
                  <div class="rfqListing">
                    <div
                      class="single-file flex justify-content-between"
                      *ngFor="let file of MultipleVideoFile; let i = index"
                    >
                      <div class="flex file">
                        <div class="rfqItem rfqTitle medium rfq-item rfq-icon">
                          <lucide-icon
                            name="FileText"
                            class="icon"
                          ></lucide-icon>
                          <h4
                            matTooltip="{{ getFileName(file?.name) }}"
                            class="name"
                          >
                            {{ getFileName(file?.name) }}.
                            <span class="name">{{
                              getFileExt(file?.name)
                            }}</span>
                          </h4>
                        </div>
                        <div class="info">
                          <h4 class="name">{{ formatBytes(file?.size) }}</h4>
                        </div>
                      </div>

                      <span
                        class="rfqItem rfqDownloadIco"
                        (click)="deleteVideoFile(i)"
                      >
                        <lucide-icon name="Trash" class="icon"></lucide-icon>
                      </span>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
            <!-- upload 3D Model  -->
            <div class="stepperCenter">
              <mat-accordion>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <h3 *ngIf="is3DMandatory">
                        Upload 3D Model for {{ temp }} (Mandatory)
                      </h3>
                      <h3 *ngIf="!is3DMandatory">
                        Upload 3D Model for {{ temp }} (Optional)
                      </h3>
                    </mat-panel-title>
                    <mat-panel-description> </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div
                    class="uploadSpecification"
                    appDnd
                    #fileDrop3D
                    id="fileDrop3D"
                    (fileDropped)="onFileDropped($event)"
                  >
                    <input
                      id="modules_rfq_createrfq_10"
                      type="file"
                      #fileSelectorMultiple
                      multiple
                      (change)="fileHandler($event)"
                      style="display: none"
                      accept=".jpeg, .jpg, .png, .pdf, .doc, .docx, .zip, .dwg, .dxf, .dgn, .stl, .step, .iges, .stp, .JPEG, .JPG, .PNG, .PDF, .DOC, .DOCX, .ZIP, .DWG, .DXF, .DGN, .STL, .STEP, .IGES, .STP"
                    />
                    <h3>Upload</h3>
                    <p class="medium font-12">(Max. file size: 100 MB)</p>
                    <span class="dwn_icon">
                      <svg
                        width="50"
                        height="48"
                        viewBox="0 0 50 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.5702 32.7618C19.5046 32.7972 19.4527 32.8535 19.4228 32.9217C19.3928 32.99 19.3865 33.0662 19.4048 33.1385C19.4231 33.2107 19.465 33.2747 19.5239 33.3205C19.5827 33.3662 19.6551 33.3909 19.7297 33.3908C19.785 33.3911 19.8395 33.3773 19.888 33.3507C19.9661 33.3085 20.0242 33.2371 20.0496 33.1521C20.0751 33.067 20.0657 32.9754 20.0235 32.8973C19.9814 32.8192 19.9099 32.7611 19.8249 32.7357C19.7399 32.7103 19.6483 32.7197 19.5702 32.7618Z"
                          fill="#999999"
                        />
                        <path
                          d="M21.0586 31.9581C20.9924 31.9932 20.94 32.0495 20.9096 32.1179C20.8792 32.1864 20.8727 32.2631 20.8911 32.3357C20.9095 32.4083 20.9517 32.4726 21.011 32.5184C21.0703 32.5642 21.1432 32.5887 21.2181 32.5881C21.2733 32.5878 21.3277 32.574 21.3764 32.548C21.4547 32.5058 21.513 32.4343 21.5385 32.3492C21.564 32.2641 21.5546 32.1723 21.5125 32.0941C21.4703 32.0159 21.3989 31.9576 21.3137 31.9321C21.2286 31.9066 21.1368 31.9159 21.0586 31.9581Z"
                          fill="#999999"
                        />
                        <path
                          d="M18.0858 33.5655C18.0203 33.6009 17.9685 33.6571 17.9385 33.7252C17.9085 33.7933 17.9021 33.8695 17.9203 33.9416C17.9385 34.0138 17.9802 34.0779 18.0388 34.1237C18.0975 34.1695 18.1697 34.1944 18.2442 34.1945C18.2998 34.1943 18.3545 34.1805 18.4036 34.1544C18.4423 34.1335 18.4765 34.1052 18.5042 34.0711C18.5319 34.0371 18.5527 33.9979 18.5653 33.9558C18.5779 33.9137 18.582 33.8695 18.5775 33.8258C18.5731 33.7821 18.56 33.7397 18.5391 33.701C18.5183 33.6624 18.49 33.6282 18.4559 33.6005C18.4218 33.5727 18.3826 33.552 18.3405 33.5394C18.2984 33.5268 18.2543 33.5227 18.2106 33.5271C18.1669 33.5316 18.1245 33.5447 18.0858 33.5655Z"
                          fill="#999999"
                        />
                        <path
                          d="M22.9998 31.2903C22.9716 31.2383 22.9301 31.1947 22.8796 31.164C22.8291 31.1333 22.7713 31.1164 22.7122 31.1153C22.653 31.1141 22.5947 31.1287 22.543 31.1574C22.4913 31.1862 22.4482 31.2281 22.418 31.279C22.3878 31.3299 22.3716 31.3878 22.3711 31.4469C22.3706 31.5061 22.3858 31.5643 22.4151 31.6157C22.4444 31.667 22.4868 31.7097 22.538 31.7393C22.5892 31.769 22.6473 31.7845 22.7065 31.7843C22.7618 31.7847 22.8163 31.7709 22.8648 31.7442C22.9035 31.7233 22.9377 31.6949 22.9654 31.6608C22.9931 31.6267 23.0139 31.5874 23.0264 31.5452C23.0389 31.5031 23.043 31.4589 23.0385 31.4151C23.0339 31.3714 23.0207 31.329 22.9998 31.2903Z"
                          fill="#999999"
                        />
                        <path
                          d="M10.6366 37.5831C10.571 37.6185 10.5191 37.6748 10.4892 37.743C10.4592 37.8112 10.4529 37.8875 10.4712 37.9598C10.4895 38.032 10.5314 38.096 10.5903 38.1417C10.6491 38.1875 10.7215 38.2122 10.7961 38.2121C10.8514 38.2124 10.9059 38.1986 10.9544 38.1719C11.0325 38.1298 11.0906 38.0584 11.1161 37.9733C11.1415 37.8883 11.1321 37.7967 11.0899 37.7186C11.0478 37.6405 10.9763 37.5824 10.8913 37.557C10.8063 37.5316 10.7147 37.541 10.6366 37.5831Z"
                          fill="#999999"
                        />
                        <path
                          d="M13.6151 35.9763C13.5496 36.0116 13.4978 36.0678 13.4678 36.1359C13.4378 36.204 13.4314 36.2802 13.4496 36.3524C13.4677 36.4245 13.5095 36.4886 13.5681 36.5344C13.6268 36.5802 13.699 36.6051 13.7735 36.6052C13.8288 36.6056 13.8833 36.5918 13.9318 36.5651C14.0063 36.5212 14.0608 36.4501 14.0841 36.3669C14.1073 36.2836 14.0974 36.1946 14.0565 36.1185C14.0155 36.0423 13.9467 35.985 13.8644 35.9585C13.7821 35.932 13.6928 35.9384 13.6151 35.9763Z"
                          fill="#999999"
                        />
                        <path
                          d="M16.5936 34.3702C16.5281 34.4056 16.4763 34.4617 16.4463 34.5299C16.4163 34.598 16.4099 34.6741 16.4281 34.7463C16.4463 34.8185 16.488 34.8825 16.5466 34.9283C16.6053 34.9741 16.6776 34.9991 16.752 34.9992C16.8029 34.9993 16.8532 34.9877 16.899 34.9654C16.9448 34.9431 16.9849 34.9107 17.0162 34.8705C17.0476 34.8304 17.0693 34.7836 17.0799 34.7338C17.0904 34.6839 17.0894 34.6323 17.077 34.583C17.0645 34.5336 17.041 34.4877 17.0081 34.4487C16.9752 34.4098 16.9339 34.3789 16.8873 34.3584C16.8407 34.3379 16.79 34.3283 16.7391 34.3303C16.6882 34.3324 16.6384 34.346 16.5936 34.3702Z"
                          fill="#999999"
                        />
                        <path
                          d="M12.1249 36.7797C12.0593 36.8151 12.0074 36.8713 11.9775 36.9396C11.9475 37.0078 11.9412 37.0841 11.9595 37.1563C11.9778 37.2285 12.0197 37.2926 12.0785 37.3383C12.1374 37.384 12.2098 37.4088 12.2843 37.4086C12.34 37.4083 12.3947 37.3946 12.4438 37.3685C12.5219 37.3262 12.58 37.2546 12.6053 37.1695C12.6306 37.0844 12.621 36.9927 12.5788 36.9146C12.5365 36.8365 12.4649 36.7784 12.3798 36.7531C12.2946 36.7278 12.203 36.7374 12.1249 36.7797Z"
                          fill="#999999"
                        />
                        <path
                          d="M15.1034 35.173C15.0379 35.2083 14.9861 35.2645 14.9561 35.3326C14.9261 35.4007 14.9197 35.4769 14.9379 35.5491C14.956 35.6212 14.9977 35.6853 15.0564 35.7311C15.1151 35.7769 15.1873 35.8018 15.2617 35.8019C15.3174 35.8016 15.3721 35.7878 15.4212 35.7618C15.4599 35.7409 15.4941 35.7126 15.5218 35.6786C15.5495 35.6445 15.5703 35.6053 15.5828 35.5632C15.5954 35.5211 15.5996 35.4769 15.5951 35.4332C15.5906 35.3895 15.5776 35.3471 15.5567 35.3085C15.5358 35.2698 15.5076 35.2356 15.4735 35.2079C15.4394 35.1802 15.4002 35.1594 15.3581 35.1468C15.316 35.1342 15.2719 35.1301 15.2281 35.1346C15.1844 35.139 15.142 35.1521 15.1034 35.173Z"
                          fill="#999999"
                        />
                        <path
                          d="M29.5983 32.614C29.54 32.5827 29.4738 32.5694 29.408 32.5758C29.3421 32.5821 29.2797 32.6078 29.2284 32.6496C29.1772 32.6914 29.1395 32.7475 29.1202 32.8107C29.1008 32.8739 29.1006 32.9415 29.1196 33.0048C29.1385 33.0682 29.1759 33.1245 29.2268 33.1666C29.2778 33.2087 29.3401 33.2348 29.4059 33.2416C29.4717 33.2483 29.538 33.2354 29.5964 33.2045C29.6549 33.1736 29.7029 33.1261 29.7343 33.0679C29.7553 33.0292 29.7683 32.9867 29.7728 32.9429C29.7773 32.8991 29.7731 32.8549 29.7605 32.8127C29.7479 32.7705 29.727 32.7313 29.6992 32.6972C29.6713 32.6631 29.6371 32.6348 29.5983 32.614Z"
                          fill="#999999"
                        />
                        <path
                          d="M35.5543 35.8286C35.5155 35.8048 35.4723 35.7892 35.4273 35.7827C35.3823 35.7762 35.3365 35.779 35.2926 35.7908C35.2487 35.8026 35.2077 35.8232 35.172 35.8514C35.1364 35.8796 35.1068 35.9147 35.0852 35.9547C35.0636 35.9947 35.0503 36.0387 35.0463 36.0839C35.0422 36.1292 35.0474 36.1748 35.0616 36.218C35.0757 36.2612 35.0985 36.3011 35.1286 36.3352C35.1586 36.3692 35.1953 36.3968 35.2364 36.4163C35.2848 36.4433 35.3393 36.4575 35.3948 36.4575C35.4693 36.4577 35.5417 36.4329 35.6006 36.3872C35.6594 36.3415 35.7013 36.2774 35.7196 36.2052C35.738 36.133 35.7316 36.0567 35.7017 35.9885C35.6717 35.9202 35.6198 35.864 35.5543 35.8286Z"
                          fill="#999999"
                        />
                        <path
                          d="M37.0444 36.6321C36.9863 36.6006 36.9201 36.5871 36.8542 36.5933C36.7883 36.5994 36.7258 36.6249 36.6744 36.6666C36.6231 36.7083 36.5853 36.7643 36.5657 36.8275C36.5462 36.8907 36.5458 36.9583 36.5647 37.0217C36.5835 37.0851 36.6207 37.1415 36.6716 37.1837C36.7225 37.226 36.7848 37.2522 36.8506 37.2591C36.9164 37.266 36.9827 37.2532 37.0412 37.2224C37.0998 37.1916 37.1478 37.1441 37.1794 37.0859C37.2004 37.0473 37.2135 37.0049 37.2181 36.9611C37.2227 36.9174 37.2186 36.8732 37.206 36.831C37.1935 36.7889 37.1728 36.7496 37.145 36.7154C37.1173 36.6813 37.0831 36.653 37.0444 36.6321Z"
                          fill="#999999"
                        />
                        <path
                          d="M38.5327 37.4348C38.4745 37.4033 38.4083 37.3898 38.3425 37.396C38.2766 37.4021 38.2141 37.4277 38.1627 37.4694C38.1114 37.5111 38.0735 37.5671 38.054 37.6303C38.0345 37.6935 38.0341 37.761 38.0529 37.8244C38.0718 37.8878 38.109 37.9442 38.1599 37.9865C38.2108 38.0287 38.2731 38.055 38.3388 38.0618C38.4046 38.0687 38.471 38.0559 38.5295 38.0251C38.588 37.9943 38.6361 37.9468 38.6677 37.8887C38.6886 37.85 38.7018 37.8076 38.7064 37.7639C38.7109 37.7201 38.7068 37.6759 38.6943 37.6338C38.6818 37.5916 38.6611 37.5523 38.6333 37.5182C38.6056 37.484 38.5714 37.4557 38.5327 37.4348Z"
                          fill="#999999"
                        />
                        <path
                          d="M34.0659 35.0246C34.0077 34.9932 33.9415 34.9797 33.8757 34.9858C33.8098 34.992 33.7473 35.0175 33.6959 35.0592C33.6446 35.1009 33.6067 35.1569 33.5872 35.2201C33.5677 35.2833 33.5673 35.3509 33.5861 35.4143C33.605 35.4777 33.6422 35.5341 33.6931 35.5763C33.744 35.6186 33.8063 35.6448 33.872 35.6517C33.9378 35.6586 34.0042 35.6458 34.0627 35.615C34.1212 35.5841 34.1693 35.5366 34.2009 35.4785C34.2218 35.4399 34.235 35.3974 34.2396 35.3537C34.2441 35.31 34.24 35.2657 34.2275 35.2236C34.215 35.1814 34.1943 35.1422 34.1665 35.108C34.1388 35.0739 34.1046 35.0455 34.0659 35.0246Z"
                          fill="#999999"
                        />
                        <path
                          d="M31.0879 33.4175C31.0297 33.3859 30.9634 33.3723 30.8975 33.3784C30.8316 33.3845 30.7689 33.41 30.7175 33.4517C30.6661 33.4934 30.6282 33.5495 30.6087 33.6127C30.5891 33.676 30.5888 33.7436 30.6077 33.8071C30.6266 33.8705 30.6639 33.9269 30.7149 33.9692C30.7659 34.0114 30.8283 34.0376 30.8941 34.0443C30.96 34.0511 31.0264 34.0382 31.0849 34.0072C31.1434 33.9762 31.1914 33.9285 31.2228 33.8702C31.2648 33.7923 31.2742 33.7008 31.2489 33.616C31.2236 33.5311 31.1657 33.4597 31.0879 33.4175Z"
                          fill="#999999"
                        />
                        <path
                          d="M32.5762 34.2221C32.518 34.1906 32.4517 34.177 32.3858 34.1831C32.3199 34.1892 32.2572 34.2147 32.2058 34.2564C32.1544 34.2981 32.1165 34.3541 32.097 34.4174C32.0774 34.4807 32.0771 34.5483 32.096 34.6118C32.1149 34.6752 32.1522 34.7316 32.2032 34.7739C32.2542 34.8161 32.3166 34.8422 32.3824 34.849C32.4483 34.8558 32.5147 34.8428 32.5732 34.8118C32.6317 34.7809 32.6797 34.7332 32.7111 34.6749C32.7531 34.597 32.7625 34.5055 32.7372 34.4206C32.7119 34.3358 32.654 34.2644 32.5762 34.2221Z"
                          fill="#999999"
                        />
                        <path
                          d="M26.62 31.0066C26.5423 30.9686 26.4529 30.9623 26.3707 30.9888C26.2884 31.0153 26.2195 31.0726 26.1786 31.1487C26.1376 31.2249 26.1277 31.3139 26.151 31.3972C26.1742 31.4804 26.2288 31.5515 26.3033 31.5954C26.3517 31.6224 26.4062 31.6366 26.4616 31.6366C26.5364 31.637 26.6092 31.6122 26.6683 31.5664C26.7274 31.5205 26.7694 31.4562 26.7876 31.3836C26.8058 31.3111 26.7992 31.2345 26.7689 31.1662C26.7385 31.0978 26.686 31.0416 26.62 31.0066Z"
                          fill="#999999"
                        />
                        <path
                          d="M28.1087 31.8107C28.07 31.7898 28.0277 31.7767 27.9839 31.7723C27.9402 31.7678 27.8961 31.7719 27.854 31.7845C27.8119 31.7971 27.7727 31.8179 27.7386 31.8456C27.7045 31.8733 27.6763 31.9075 27.6554 31.9462C27.6345 31.9848 27.6215 32.0272 27.617 32.0709C27.6125 32.1146 27.6167 32.1588 27.6292 32.2009C27.6418 32.243 27.6626 32.2822 27.6903 32.3163C27.718 32.3503 27.7522 32.3786 27.7909 32.3995C27.84 32.4257 27.8947 32.4394 27.9504 32.4396C28.0248 32.4395 28.097 32.4146 28.1557 32.3688C28.2144 32.323 28.2561 32.2589 28.2742 32.1868C28.2924 32.1146 28.286 32.0384 28.256 31.9703C28.226 31.9022 28.1742 31.846 28.1087 31.8107Z"
                          fill="#999999"
                        />
                        <path
                          d="M24.7213 13.0754C24.906 13.0754 25.0558 12.9256 25.0558 12.7408C25.0558 12.556 24.906 12.4062 24.7213 12.4062C24.5365 12.4062 24.3867 12.556 24.3867 12.7408C24.3867 12.9256 24.5365 13.0754 24.7213 13.0754Z"
                          fill="#999999"
                        />
                        <path
                          d="M24.7213 16.4211C24.906 16.4211 25.0558 16.2713 25.0558 16.0865C25.0558 15.9017 24.906 15.752 24.7213 15.752C24.5365 15.752 24.3867 15.9017 24.3867 16.0865C24.3867 16.2713 24.5365 16.4211 24.7213 16.4211Z"
                          fill="#999999"
                        />
                        <path
                          d="M24.7213 18.0939C24.906 18.0939 25.0558 17.9441 25.0558 17.7594C25.0558 17.5746 24.906 17.4248 24.7213 17.4248C24.5365 17.4248 24.3867 17.5746 24.3867 17.7594C24.3867 17.9441 24.5365 18.0939 24.7213 18.0939Z"
                          fill="#999999"
                        />
                        <path
                          d="M24.7213 19.7668C24.906 19.7668 25.0558 19.617 25.0558 19.4322C25.0558 19.2474 24.906 19.0977 24.7213 19.0977C24.5365 19.0977 24.3867 19.2474 24.3867 19.4322C24.3867 19.617 24.5365 19.7668 24.7213 19.7668Z"
                          fill="#999999"
                        />
                        <path
                          d="M24.7213 14.7482C24.906 14.7482 25.0558 14.5984 25.0558 14.4137C25.0558 14.2289 24.906 14.0791 24.7213 14.0791C24.5365 14.0791 24.3867 14.2289 24.3867 14.4137C24.3867 14.5984 24.5365 14.7482 24.7213 14.7482Z"
                          fill="#999999"
                        />
                        <path
                          d="M24.7213 23.1125C24.906 23.1125 25.0558 22.9627 25.0558 22.7779C25.0558 22.5931 24.906 22.4434 24.7213 22.4434C24.5365 22.4434 24.3867 22.5931 24.3867 22.7779C24.3867 22.9627 24.5365 23.1125 24.7213 23.1125Z"
                          fill="#999999"
                        />
                        <path
                          d="M24.7213 26.4582C24.906 26.4582 25.0558 26.3084 25.0558 26.1236C25.0558 25.9388 24.906 25.7891 24.7213 25.7891C24.5365 25.7891 24.3867 25.9388 24.3867 26.1236C24.3867 26.3084 24.5365 26.4582 24.7213 26.4582Z"
                          fill="#999999"
                        />
                        <path
                          d="M24.7213 24.7853C24.906 24.7853 25.0558 24.6355 25.0558 24.4508C25.0558 24.266 24.906 24.1162 24.7213 24.1162C24.5365 24.1162 24.3867 24.266 24.3867 24.4508C24.3867 24.6355 24.5365 24.7853 24.7213 24.7853Z"
                          fill="#999999"
                        />
                        <path
                          d="M24.7213 21.4396C24.906 21.4396 25.0558 21.2898 25.0558 21.1051C25.0558 20.9203 24.906 20.7705 24.7213 20.7705C24.5365 20.7705 24.3867 20.9203 24.3867 21.1051C24.3867 21.2898 24.5365 21.4396 24.7213 21.4396Z"
                          fill="#999999"
                        />
                        <path
                          d="M49.7396 43.5147L49.2388 41.8575C49.2131 41.7725 49.1547 41.7012 49.0763 41.6592C48.998 41.6173 48.9062 41.6082 48.8212 41.6339C48.7362 41.6597 48.6648 41.7181 48.6229 41.7964C48.581 41.8748 48.5719 41.9665 48.5976 42.0516L48.8842 42.9984L41.1125 38.8309V19.392C41.1124 19.2613 41.077 19.133 41.01 19.0208C40.9431 18.9085 40.8471 18.8164 40.7322 18.7541L25.066 10.2999H25.0559V1.15753L25.7574 1.85898C25.8217 1.9135 25.9041 1.94177 25.9883 1.93812C26.0725 1.93448 26.1522 1.89919 26.2115 1.83932C26.2708 1.77946 26.3054 1.69941 26.3082 1.61519C26.3111 1.53096 26.282 1.44877 26.2269 1.38503L25.0002 0.158319C24.9702 0.109905 24.9283 0.0699526 24.8785 0.0422472C24.8288 0.0145417 24.7728 0 24.7158 0C24.6588 0 24.6028 0.0145417 24.5531 0.0422472C24.5033 0.0699526 24.4614 0.109905 24.4314 0.158319L23.2047 1.38503C23.1736 1.41608 23.1489 1.45295 23.132 1.49354C23.1152 1.53413 23.1064 1.57765 23.1064 1.62161C23.1063 1.66557 23.115 1.70911 23.1317 1.74974C23.1485 1.79037 23.1731 1.82731 23.2042 1.85843C23.2352 1.88955 23.2721 1.91425 23.3127 1.93112C23.3533 1.94799 23.3968 1.9567 23.4407 1.95675C23.4847 1.9568 23.5282 1.94819 23.5689 1.93142C23.6095 1.91464 23.6464 1.89003 23.6776 1.85898L24.3779 1.15753V10.2954C24.375 10.2948 24.3719 10.2948 24.369 10.2954L8.71171 18.7575C8.59648 18.8195 8.50018 18.9115 8.43303 19.0238C8.36589 19.1361 8.33039 19.2645 8.33031 19.3954V38.8164C8.33031 38.822 8.33031 38.8275 8.33031 38.8331L1.10611 42.8144L1.38267 41.862C1.40737 41.7767 1.39716 41.685 1.35429 41.6072C1.31141 41.5294 1.23939 41.4718 1.15406 41.4471C1.06873 41.4224 0.977087 41.4326 0.899287 41.4755C0.821488 41.5184 0.763906 41.5904 0.73921 41.6757L0.257447 43.3385C0.229512 43.3884 0.214844 43.4447 0.214844 43.5019C0.214844 43.5591 0.229512 43.6153 0.257447 43.6652C0.284951 43.7144 0.32441 43.7558 0.372171 43.7856C0.419932 43.8154 0.474448 43.8327 0.530669 43.8359L2.20345 44.3187C2.28878 44.3434 2.38043 44.3332 2.45823 44.2904C2.53603 44.2475 2.59361 44.1755 2.61831 44.0901C2.643 44.0048 2.63279 43.9132 2.58992 43.8354C2.54704 43.7576 2.47502 43.7 2.38969 43.6753L1.43063 43.4032L8.65483 39.4231C8.67313 39.4356 8.69212 39.4472 8.71171 39.4576L24.3779 47.913C24.4836 47.9701 24.6018 48 24.7219 48C24.8421 48 24.9603 47.9701 25.066 47.913L40.7322 39.4576C40.7538 39.4459 40.7746 39.4329 40.7946 39.4186L48.5697 43.5961L47.6196 43.8827C47.5429 43.906 47.4771 43.9561 47.4343 44.0239C47.3914 44.0916 47.3743 44.1725 47.3861 44.2518C47.3978 44.3311 47.4376 44.4036 47.4983 44.456C47.559 44.5084 47.6364 44.5372 47.7166 44.5373C47.7495 44.5374 47.7822 44.5325 47.8136 44.5228L49.4764 44.021C49.5325 44.0164 49.5866 43.9977 49.6336 43.9667C49.6805 43.9357 49.7189 43.8933 49.7452 43.8435C49.7714 43.7936 49.7847 43.738 49.7837 43.6817C49.7827 43.6254 49.7675 43.5703 49.7396 43.5214V43.5147ZM24.7214 11.7608L38.862 19.392L24.7214 27.0233L10.5819 19.392L24.7214 11.7608ZM9.77783 20.6065L23.9965 28.279V46.0562L9.78006 38.3848L9.77783 20.6065ZM25.4463 46.0562V28.279L39.6627 20.6065V38.3848L25.4463 46.0562Z"
                          fill="#999999"
                        />
                      </svg>
                    </span>
                    <p class="mb-4 font-12">Drag &amp; Drop or</p>
                    <button
                      id="modules_rfq_createrfq_11"
                      class="btnCustom btn-rfq"
                      (click)="chooseFiles()"
                    >
                      Choose File
                    </button>
                    <p class="mb-0 mt-5 medium font-10">
                      JPEG | JPG | PNG | PDF | DOC | DOCX | ZIP | DWG | DXF |
                      DGN | STL | STEP | IGES | STP
                    </p>
                  </div>
                  <!-- <div class="downloadComponent">
                                        <button *ngIf="is3DMandatory == false" matStepperNext>Skip for now</button>
                                    </div>  -->
                  <div class="rfqListing">
                    <!-- <h3 class="font-12 medium">RFQ</h3> -->
                    <div
                      class="single-file flex justify-content-between"
                      *ngFor="let file of files; let i = index"
                    >
                      <div class="flex file">
                        <div class="rfqItem rfqTitle medium rfq-item rfq-icon">
                          <lucide-icon
                            name="FileText"
                            class="icon"
                          ></lucide-icon>
                          <h4
                            matTooltip="{{ getFileName(file?.name) }}"
                            class="name"
                          >
                            {{ getFileName(file?.name) }}.<span class="name">{{
                              getFileExt(file?.name)
                            }}</span>
                          </h4>
                        </div>
                        <div class="info">
                          <h4 class="name">{{ formatBytes(file?.size) }}</h4>
                        </div>
                      </div>

                      <span
                        class="rfqItem rfqDownloadIco"
                        (click)="delete3DFile(i)"
                      >
                        <lucide-icon name="Trash" class="icon"></lucide-icon>
                      </span>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
            <!-- Upload TNC File -->
            <div class="stepperCenter">
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h3>Upload T&C(Optional)</h3>
                  </mat-panel-title>
                  <mat-panel-description> </mat-panel-description>
                </mat-expansion-panel-header>
                <app-upload-dnd
                  (fileUploadEvent)="tncfileUploadEvent($event)"
                  [documentInfo]="documentInfo"
                  [fileUploadConfig]="fileUploadConfig"
                  [resetFileUpload]="resetFileUpload"
                ></app-upload-dnd>
              </mat-expansion-panel>
              <div *ngIf="isSkipnow" class="downloadComponent">
                <button
                  id="modules_rfq_createrfq_12"
                  class="iconCenter"
                  *ngIf="isSkipnow"
                  (click)="skipForNow()"
                  matStepperNext
                >
                  Skip for now
                </button>
              </div>
              <div class="saveButton">
                <button
                  id="modules_rfq_createrfq_13"
                  mat-button
                  color="primary"
                  type="button"
                  class="btnCustom btn-primary"
                  matStepperNext
                  (click)="update2D3DRFQFile()"
                  [ngClass]="{
                    disable:
                      (is3DMandatory == true && is3DFileUploaded == false) ||
                      (is2DMandatory == true && is2DFileUploaded == false)
                  }"
                  [disabled]="
                    (is3DMandatory == true && is3DFileUploaded == false) ||
                    (is2DMandatory == true && is2DFileUploaded == false)
                  "
                >
                  Save & Continue
                </button>
              </div>
            </div>
          </div>
        </mat-step>
        <mat-step label="Submit RFQ">
          <div class="stepperWrapp">
            <div class="stepperCenter">
              <span class="back-step-button" (click)="backStep(stepper)">
                <lucide-icon name="ArrowLeft" class="back-icon"></lucide-icon>
                Back
              </span>
              <div class="uploadSpecification lastTab">
                <h3>Confirm & Send RFQ</h3>
                <p class="font-12 confirm_label">
                  Submit your quote to get a tailored solution
                </p>
              </div>
              <div class="rfqListing">
                <h3 class="font-12 medium">RFQ</h3>
                <div *ngIf="SingleFile" class="files-list">
                  <div class="single-file flex justify-content-between">
                    <div class="flex file">
                      <div class="rfq-item rfq-icon">
                        <lucide-icon name="FileText" class="icon"></lucide-icon>
                        <h4>
                          {{ getFileName(SingleFile.name) }}.<span
                            class="name"
                            >{{ getFileExt(SingleFile.name) }}</span
                          >
                        </h4>
                      </div>
                      <div class="info">
                        <h4 class="name">{{ formatBytes(SingleFile.size) }}</h4>
                      </div>
                    </div>
                  </div>
                </div>

                <h3 class="font-12 medium">3D Drawings</h3>
                <div *ngIf="files.length > 0" class="files-list">
                  <div
                    class="single-file flex justify-content-between"
                    *ngFor="let file of files; let i = index"
                  >
                    <div class="flex file">
                      <div class="rfq-item rfq-icon">
                        <lucide-icon name="FileText" class="icon"></lucide-icon>
                        <h4
                          class="name"
                          matTooltip="{{ getFileName(file?.name) }}"
                        >
                          {{ getFileName(file?.name) }}.<span class="name">{{
                            getFileExt(file?.name)
                          }}</span>
                        </h4>
                      </div>
                      <div class="info">
                        <h4 class="name">{{ formatBytes(file?.size) }}</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <h3 class="font-12 medium">2D Drawings</h3>
                <div *ngIf="Multiple2DFile.length > 0" class="files-list">
                  <div
                    class="single-file flex justify-content-between"
                    *ngFor="let file of Multiple2DFile; let i = index"
                  >
                    <div class="flex file">
                      <div class="rfq-item rfq-icon">
                        <lucide-icon name="FileText" class="icon"></lucide-icon>
                        <h4
                          class="name"
                          matTooltip="{{ getFileName(file?.name) }}"
                        >
                          {{ getFileName(file?.name) }}.<span class="name">{{
                            getFileExt(file?.name)
                          }}</span>
                        </h4>
                      </div>

                      <div class="info">
                        <h4 class="name">{{ formatBytes(file?.size) }}</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <h3 class="font-12 medium">T&C File</h3>
                <div *ngIf="tncAttachment.length > 0" class="files-list">
                  <div
                    class="single-file flex justify-content-between"
                    *ngFor="let file of tncAttachment; let i = index"
                  >
                    <div class="flex file">
                      <div class="rfq-item rfq-icon">
                        <lucide-icon name="FileText" class="icon"></lucide-icon>
                        <h4 class="name" matTooltip="{{ file?.fileName }}">
                          {{ file?.fileName }}
                        </h4>
                      </div>

                      <div class="info">
                        <h4 class="name">{{ file?.size }}</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="isVideoSelection">
                  <h3 class="font-12 medium">Videos</h3>
                  <div *ngIf="MultipleVideoFile.length > 0" class="files-list">
                    <div
                      class="single-file flex justify-content-between"
                      *ngFor="let file of MultipleVideoFile; let i = index"
                    >
                      <div class="flex file">
                        <div class="rfq-item rfq-icon">
                          <lucide-icon
                            name="FileText"
                            class="icon"
                          ></lucide-icon>
                          <h4
                            class="name"
                            matTooltip="{{ getFileName(file?.name) }}"
                          >
                            {{ getFileName(file?.name) }}
                          </h4>
                        </div>

                        <div class="info">
                          <h4 class="name">{{ formatBytes(file?.size) }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="saveButton">
                <button
                  id="modules_rfq_createrfq_14"
                  type="button"
                  class="btnCustom btn-primary sendRfq"
                  (click)="UpdateRFQStatus()"
                >
                  Send RFQ
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M3.2175 5.5275L10.1017 8.47917L3.20833 7.5625L3.2175 5.5275ZM10.0925 13.5208L3.20833 16.4725V14.4375L10.0925 13.5208ZM1.38417 2.75L1.375 9.16667L15.125 11L1.375 12.8333L1.38417 19.25L20.625 11L1.38417 2.75Z"
                      fill="white"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </mat-step>
      </mat-stepper>
    </form>
    <div class="rfqRecieved" *ngIf="isHide">
      <div class="content">
        <div class="icons">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="76"
            height="72"
            viewBox="0 0 76 72"
            fill="none"
          >
            <g clip-path="url(#clip0_7835_9913)">
              <path
                d="M13.3381 1.51017C12.02 1.51017 10.9523 2.56469 10.9523 3.86656V57.5622C10.9523 58.8641 12.02 59.9186 13.3381 59.9186H49.7245C51.0426 59.9186 52.1103 58.8641 52.1103 57.5622V3.86656C52.1103 2.56469 51.0426 1.51017 49.7245 1.51017H13.3381ZM49.7245 61.4288H13.3381C11.1764 61.4288 9.42334 59.6908 9.42334 57.5622V3.86656C9.42334 1.73149 11.1764 0 13.3381 0H49.7245C51.8796 0 53.6393 1.738 53.6393 3.86656V57.5622C53.6393 59.6973 51.8862 61.4288 49.7245 61.4288Z"
                fill="#DA2128"
              />
              <path
                d="M16.7873 4.91479C15.4692 4.91479 14.4016 5.96931 14.4016 7.27118V60.9669C14.4016 62.2687 15.4692 63.3232 16.7873 63.3232H53.1738C54.4919 63.3232 55.5595 62.2687 55.5595 60.9669V7.27769C55.5595 5.97582 54.4919 4.9213 53.1738 4.9213H16.7873V4.91479ZM53.1738 64.8334H16.7873C14.6256 64.8334 12.8726 63.0954 12.8726 60.9669V7.27769C12.8726 5.14262 14.6256 3.41113 16.7873 3.41113H53.1738C55.3289 3.41113 57.0885 5.14913 57.0885 7.27769V60.9734C57.0885 63.1084 55.3355 64.8399 53.1738 64.8399V64.8334Z"
                fill="#DA2128"
              />
              <path
                d="M20.2336 8.3256C18.9155 8.3256 17.8479 9.38012 17.8479 10.682V64.3777C17.8479 65.6795 18.9155 66.7341 20.2336 66.7341H56.62C57.9381 66.7341 59.0058 65.6795 59.0058 64.3777V10.682C59.0058 9.38012 57.9381 8.3256 56.62 8.3256H20.2336ZM56.62 68.2442H20.2336C18.0719 68.2442 16.3188 66.5062 16.3188 64.3777V10.682C16.3188 8.54692 18.0719 6.81543 20.2336 6.81543H56.62C58.7751 6.81543 60.5348 8.55343 60.5348 10.682V64.3777C60.5348 66.5127 58.7817 68.2442 56.62 68.2442Z"
                fill="#DA2128"
              />
              <path
                d="M54.8939 58.7402H50.3003V63.2707H54.8939V58.7402Z"
                fill="white"
              />
              <path
                d="M44.763 58.7402H40.1694V63.2707H44.763V58.7402Z"
                fill="white"
              />
              <path
                d="M34.6344 58.7402H30.0474V63.2707H34.6344V58.7402Z"
                fill="white"
              />
              <path
                d="M54.8939 48.5796H50.3003V53.1101H54.8939V48.5796Z"
                fill="white"
              />
              <path
                d="M44.763 48.5791H40.1694V53.1096H44.763V48.5791Z"
                fill="white"
              />
              <path
                d="M34.6344 48.5796H30.0474V53.1101H34.6344V48.5796Z"
                fill="white"
              />
              <path
                d="M54.8939 38.418H50.3003V42.9485H54.8939V38.418Z"
                fill="white"
              />
              <path
                d="M44.763 38.4185H40.1694V42.949H44.763V38.4185Z"
                fill="white"
              />
              <path
                d="M34.6344 38.418H30.0474V42.9485H34.6344V38.418Z"
                fill="white"
              />
              <path
                d="M58.2142 30.7632H26.7246V31.8698H58.2142V30.7632Z"
                fill="white"
              />
              <path
                d="M58.2142 19.2871H26.7246V25.0219H58.2142V19.2871Z"
                fill="#DA2128"
              />
              <path
                d="M63.0462 14.4316V68.1273C63.0462 69.4226 61.9785 70.4837 60.6604 70.4837H24.274C22.9624 70.4837 21.8882 69.4226 21.8882 68.1273V14.4316C21.8882 13.1297 22.9624 12.0752 24.274 12.0752H60.6604C61.9785 12.0752 63.0462 13.1297 63.0462 14.4316ZM60.5879 64.4169V47.2257H59.0589V64.4169C59.0589 65.7188 57.9846 66.7798 56.6665 66.7798H46.2468V68.29H56.6665C58.8282 68.29 60.5813 66.552 60.5813 64.4234L60.5879 64.4169ZM59.7443 33.3738V29.2469H25.1966V33.3738H59.7443ZM59.7443 26.5325V17.7774H25.1966V26.5325H59.7443ZM56.4292 64.7815V57.2306H48.7776V64.7815H56.4292ZM56.4292 54.6204V47.0695H48.7776V54.6204H56.4292ZM56.4292 44.4592V36.9084H48.7776V44.4592H56.4292ZM46.293 64.7815V57.2306H38.6414V64.7815H46.293ZM46.293 54.6204V47.0695H38.6414V54.6204H46.293ZM46.293 44.4592V36.9084H38.6414V44.4592H46.293ZM36.1633 64.7815V57.2306H28.5183V64.7815H36.1633ZM36.1633 54.6204V47.0695H28.5183V54.6204H36.1633ZM36.1633 44.4592V36.9084H28.5183V44.4592H36.1633Z"
                fill="white"
              />
              <path
                d="M64.5744 14.431V68.1267C64.5744 70.2553 62.8213 71.9933 60.6596 71.9933H24.2732C22.1181 71.9933 20.3584 70.2553 20.3584 68.1267V14.431C20.3584 12.2959 22.1181 10.5645 24.2732 10.5645H60.6596C62.8213 10.5645 64.5744 12.2959 64.5744 14.431ZM63.0454 68.1267V14.431C63.0454 13.1291 61.9777 12.0746 60.6596 12.0746H24.2732C22.9617 12.0746 21.8874 13.1291 21.8874 14.431V68.1267C21.8874 69.4221 22.9617 70.4831 24.2732 70.4831H60.6596C61.9777 70.4831 63.0454 69.4221 63.0454 68.1267Z"
                fill="#DA2128"
              />
              <path
                d="M60.5864 47.2321V64.4233C60.5864 66.5584 58.8267 68.2899 56.6716 68.2899H46.252V66.7797H56.6716C57.9897 66.7797 59.064 65.7187 59.064 64.4168V47.2256H60.593L60.5864 47.2321Z"
                fill="white"
              />
              <path
                d="M59.7425 29.2529V33.3799H25.1948V29.2529H59.7425ZM58.2135 31.8697V30.7631H26.7238V31.8697H58.2135Z"
                fill="#DA2128"
              />
              <path
                d="M59.7425 17.7773V26.5324H25.1948V17.7773H59.7425ZM58.2135 25.0223V19.2875H26.7238V25.0223H58.2135Z"
                fill="#DA2128"
              />
              <path
                d="M56.4285 57.2305V64.7813H48.7769V57.2305H56.4285ZM54.8995 63.2712V58.7406H50.3059V63.2712H54.8995Z"
                fill="#DA2128"
              />
              <path
                d="M56.4285 47.0693V54.6202H48.7769V47.0693H56.4285ZM54.8995 53.11V48.5795H50.3059V53.11H54.8995Z"
                fill="#DA2128"
              />
              <path
                d="M56.4285 36.9082V44.4591H48.7769V36.9082H56.4285ZM54.8995 42.9489V38.4184H50.3059V42.9489H54.8995Z"
                fill="#DA2128"
              />
              <path
                d="M46.2913 57.23V64.7808H38.6396V57.23H46.2913ZM44.7623 63.2707V58.7402H40.1687V63.2707H44.7623Z"
                fill="#DA2128"
              />
              <path
                d="M46.2913 47.0693V54.6202H38.6396V47.0693H46.2913ZM44.7623 53.11V48.5795H40.1687V53.11H44.7623Z"
                fill="#DA2128"
              />
              <path
                d="M46.2913 36.9077V44.4586H38.6396V36.9077H46.2913ZM44.7623 42.9484V38.4179H40.1687V42.9484H44.7623Z"
                fill="#DA2128"
              />
              <path
                d="M36.1621 57.2305V64.7813H28.5171V57.2305H36.1621ZM34.6331 63.2712V58.7406H30.0461V63.2712H34.6331Z"
                fill="#DA2128"
              />
              <path
                d="M36.1621 47.0693V54.6202H28.5171V47.0693H36.1621ZM34.6331 53.11V48.5795H30.0461V53.11H34.6331Z"
                fill="#DA2128"
              />
              <path
                d="M36.1621 36.9082V44.4591H28.5171V36.9082H36.1621ZM34.6331 42.9489V38.4184H30.0461V42.9489H34.6331Z"
                fill="#DA2128"
              />
              <path
                d="M69.9251 9.51693C71.3223 9.51693 72.4492 8.40383 72.4492 7.02385C72.4492 5.64386 71.3223 4.53076 69.9251 4.53076C68.5279 4.53076 67.4009 5.64386 67.4009 7.02385C67.4009 8.40383 68.5279 9.51693 69.9251 9.51693ZM69.9251 6.17112C70.393 6.17112 70.7884 6.56168 70.7884 7.02385C70.7884 7.48601 70.393 7.87657 69.9251 7.87657C69.4571 7.87657 69.0617 7.48601 69.0617 7.02385C69.0617 6.56168 69.4637 6.17112 69.9251 6.17112Z"
                fill="#DA2128"
              />
              <path
                d="M74.2233 13.8521H72.5625V15.4924H74.2233V13.8521Z"
                fill="#DA2128"
              />
              <path
                d="M74.2233 17.1978H72.5625V18.8381H74.2233V17.1978Z"
                fill="#DA2128"
              />
              <path
                d="M75.9572 15.5576H74.2964V17.198H75.9572V15.5576Z"
                fill="#DA2128"
              />
              <path
                d="M72.5607 15.5576H70.8999V17.198H72.5607V15.5576Z"
                fill="#DA2128"
              />
              <path
                d="M3.901 27.606H1.9502V29.5327H3.901V27.606Z"
                fill="#DA2128"
              />
              <path
                d="M3.901 31.5312H1.9502V33.458H3.901V31.5312Z"
                fill="#DA2128"
              />
              <path
                d="M5.92541 29.6045H3.97461V31.5313H5.92541V29.6045Z"
                fill="#DA2128"
              />
              <path
                d="M1.9508 29.6045H0V31.5313H1.9508V29.6045Z"
                fill="#DA2128"
              />
            </g>
            <defs>
              <clipPath id="clip0_7835_9913">
                <rect width="75.956" height="72" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="rfqRecievedQuotation">
          <p class="headLine">RFQ Recieved</p>
        </div>
        <div class="quotes">
          <p class="medium">
            The best quote will be processed and sent within 5-7 working days.
            Your RFQ reference has been emailed to your registered ID.
          </p>
          <div class="refId">
            <p class="light">Reference ID: {{ this.rfqId }}</p>
          </div>
          <div class="refId">
            <p class="medium">
              You are on track to find the best manufacturing service!
            </p>
          </div>

          <div class="flex-parent">
            <div class="input-flex-container">
              <div class="input">
                <mat-icon>check</mat-icon>
                <span data-year="RFQ received"></span>
              </div>
              <div class="input active">
                <mat-icon>check</mat-icon>
                <span data-year="Quotes engine in progress"></span>
              </div>
              <div class="input">
                <mat-icon>radio_button_checked</mat-icon>
                <span data-year="Quote approved"></span>
              </div>
              <div class="input">
                <mat-icon>radio_button_checked</mat-icon>
                <span data-year="Production initiated"></span>
              </div>
              <div class="input">
                <mat-icon>radio_button_checked</mat-icon>
                <span data-year="Order delivered"></span>
              </div>
            </div>
          </div>

          <button
            id="modules_rfq_createrfq_15"
            mat-button
            class="btn"
            (click)="navigateToRFQList()"
          >
            View RFQ
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
